import { IngredientToAvoidIds } from 'src/utils/constants';

// When a visible allergen chip is toggled, these linked IDs are also toggled in state but not shown as separate chips
export const LINKED_INGREDIENT_IDS: Partial<Record<number, number[]>> = {
  [IngredientToAvoidIds.COCONUT]: [IngredientToAvoidIds.COCONUT_AMINOS],
  [IngredientToAvoidIds.SESAME]: [IngredientToAvoidIds.SESAME_OIL],
};

export const HIDDEN_LINKED_INGREDIENT_IDS = Object.values(
  LINKED_INGREDIENT_IDS,
).flat() as number[];
